/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_InboxInputs */

const en_mk_mx_inbox = /** @type {(inputs: Mk_Mx_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unified inbox & notifications`)
};

const id_mk_mx_inbox = /** @type {(inputs: Mk_Mx_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox terpadu & notifikasi`)
};

/**
* | output |
* | --- |
* | "Unified inbox & notifications" |
*
* @param {Mk_Mx_InboxInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_inbox = /** @type {((inputs?: Mk_Mx_InboxInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_InboxInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_inbox(inputs)
	return en_mk_mx_inbox(inputs)
});